import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 42,
  policySubType: 0,
  holderType: 2,
};

export function getDlpTeamsChatTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.MTC.tmDpfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.MTC.tmDpfilters.notification.ntfAdminSubject',
  ];
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}
